import { Component, OnDestroy, OnInit } from '@angular/core';
import { StateService } from '../services/state.service';
import { VehicleService } from '../services/vehicle.service';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})
export class MapComponent implements OnInit, OnDestroy {

  constructor(private stateSvc: StateService, private vehicleSvc: VehicleService, private apiSvc: ApiService) { }
  
  map:any = {};
  vehicles:any = [];
  markers:any = [];
  bounds:any = {};
  firstInit = false;
  
  vehicleSubs:any;
  mapInsSubs:any;
  mapLoadedFc:any;

  allDisplays = false;
  fieldDisplays:any = [];
  avFieldDisplays:any = [];
  eff_time = 1;
  share_vehicle_id:any = 0;
  baseShareUrl = "";
  globalProvider:any = "OpenStreetMap";

  ngOnInit(): void {
	this.globalProvider = this.stateSvc.getMapType();
	const self = this;
	$("body").css("cursor", "default");

	this.fieldDisplays = this.stateSvc.getMapFields();
	if(!this.fieldDisplays || this.fieldDisplays?.length == 0){
		this.fieldDisplays = this.stateSvc.getMapFieldIds();
	}else{
		let allFlds = this.stateSvc.getMapFieldIds();
		let rewriteObj:any = [];
		if(allFlds.length != this.fieldDisplays.length){
			allFlds.forEach((alf) => {
				let colX = alf;
				let excx:any = {};
				this.fieldDisplays.forEach((exd) => {
					if(exd.col == alf.col){
						excx = exd;
						return;
					}
				})
				if(excx && excx.col){
					rewriteObj.push(excx);
				}else{
					rewriteObj.push(alf);
				}
			});
			this.stateSvc.setMapFields(rewriteObj);
			this.fieldDisplays = rewriteObj;
		}
	}
	let showAll = true;
	this.fieldDisplays.forEach((avf) => {
		if(!avf.value){
			showAll = false;
		}
	})
	if(showAll){
		this.allDisplays = true;
	}

	this.stateSvc.setShowMultipleOnMap(true);
	this.stateSvc.setShowControl(true);
	this.mapInsSubs = this.stateSvc.mapInstance
	.subscribe((map) => {
		this.map = map;
		if(this.map?.mapTypeId){
			this.bounds = new google.maps.LatLngBounds();
			this.updateMapVehicle();
		}
	});
	this.mapLoadedFc = this.stateSvc.mapLoaded
	.subscribe((flag) => {console.log('firstInit', this.firstInit)
		this.firstInit = flag;
		if(this.firstInit){
			console.log('insubnscrtne')
		}
	});
	this.vehicleSubs = this.stateSvc.vehicles
	.subscribe((result) => {
		let vhcls = result;
		this.vehicles = vhcls;
		this.markers = [];
		let shownMarkers = [];
		let toUpdateVehicleObj = false;
		this.vehicles?.forEach((vhcl) => {
			if(vhcl.shownOnMap && this.map?.mapTypeId){
				if(!vhcl.marker?.getMap()){
					vhcl.marker.setMap(null);
					vhcl.marker.setMap(this.map);
				}
			}
			/*if(vhcl.shownOnMap && this.map?.mapTypeId){
				if(!vhcl.marker?.getMap()){
					vhcl.marker.setMap(this.map);
					shownMarkers.push(vhcl);
					toUpdateVehicleObj = true;
				}
			}else{
				vhcl.marker.setMap(null);
			}*/
		});
		// this.firstInit = false;
		if(toUpdateVehicleObj){
			this.vehicleSvc.updateVehicleUnit(this.vehicles, shownMarkers);
		}
		if(this.firstInit){
			this.toUpdateZoom();
		}
	});
	$(document).on('click', '.colchooser', () => {
		$('#fieldOpt').show().addClass('in');
		$('#fieldOptBackdrop').show().addClass('in');
	});
	$(document).on('click', '.refreshGeoloc', function() {
		let unitid = $(this).data('unitid');
		self.mapUpdateInfoWdw(unitid);
	});

	$(document).on('click', '.gen-share-link', function(){
		$('#expirySet').show().addClass('in');
		$('#share-unit-id').val($(this).data('vehicle-id'));
		$('#fieldOptBackdrop').show().addClass('in');

		self.share_vehicle_id = $(this).data('vehicle-id');
		self.confirmShare();
	});

	$(document).on('click', '#copyBtn', () => {
		var copyText:any = this.baseShareUrl;
		console.log('recommended')
		// Modern way (recommended)
		if (navigator.clipboard) {console.log('recommended2')
			navigator.clipboard.writeText(copyText).then(() => {
				$(".noti-copied").removeClass('force-hide');
				setTimeout(() => {
					$(".noti-copied").addClass('force-hide');
				}, 3500)
			}).catch((err) => {console.log('recommended3')
				console.error("Failed to copy: ", err);
			});
		} 
	});
  }
  
  toUpdateZoom(){
	let currentMapProvider = this.stateSvc.getMapType();
	if(currentMapProvider == "Google"){
		this.bounds = new google.maps.LatLngBounds();
		let zeroSelected = true;
		this.vehicles.forEach((vehicle) => {
			if (vehicle.marker?.getMap()) {
				this.bounds.extend(vehicle.marker.getPosition());
			}
			if(vehicle.shownOnMap){
				zeroSelected = false;
			}
		});
		if(this.map?.mapTypeId && this.bounds && !zeroSelected){
			this.map.fitBounds(this.bounds);
			if(this.map?.getZoom() > 16){
				this.map?.setZoom(16);
			}
		}
	}else{
		this.bounds = [];
		let zeroSelected = true;
		this.vehicles.forEach((vehicle) => {
			if(vehicle.shownOnMap){
				zeroSelected = false;
				this.bounds.push(vehicle.markerPositionOsm);
			}
		});
		if(this.map && this.bounds.length > 0 && !zeroSelected){
			setTimeout(() => {
				this.map.fitBounds(this.bounds, { padding: [20, 20] });
			},100)
			// if(this.map?.getZoom() > 16){
			// 	this.map?.setZoom(16);
			// }
		}
	}
  }
  
  updateMapVehicle(){
	this.vehicles?.forEach((vhcl) => {
		if(vhcl.shownOnMap && this.map?.mapTypeId){
			if(!vhcl.marker?.getMap() || (this.map != vhcl.marker?.getMap())){
				vhcl.marker.setMap(null);
				vhcl.marker.setMap(this.map);
				vhcl.infoWindow = new google.maps.InfoWindow({
					content: vhcl.infowWindowContent
				});
				vhcl.infoWindow.shown = false;
				google.maps.event.clearListeners(vhcl.marker, 'click');
				vhcl.marker.addListener('click', () => {
					if (!vhcl.infoWindow.shown) {
						vhcl.infoWindow.open(vhcl.marker?.map, vhcl.marker);
						vhcl.infoWindow.shown = true;
						vhcl.toggleInfoWdw = true;
					} else {
						vhcl.infoWindow.close();
						vhcl.infoWindow.shown = false;
						vhcl.toggleInfoWdw = false;
					}
					//this.vehicleSvc.updateInfoWd(vhcl);
				});
				google.maps.event.addListener(vhcl.infoWindow,'closeclick',() => {
					vhcl.infoWindow.shown = false;
					vhcl.toggleInfoWdw = false;
					//this.vehicleSvc.updateInfoWd(vhcl);
				});
			}
		}
	});
  }
  
  ngOnDestroy(){
	this.vehicleSubs.unsubscribe();
	this.mapInsSubs.unsubscribe();
	this.mapLoadedFc.unsubscribe();
  }

  saveFields(saveNot:any){
	if(saveNot){
		this.stateSvc.setMapFields(this.fieldDisplays);
		this.vehicles.forEach((vehicle) => {
			if(vehicle.infoWindow.shown){
				vehicle.infowWindowContent = this.vehicleSvc.writeInfoContent(vehicle, vehicle.othersAttribute, vehicle.geolocation);
				vehicle.infoWindow.setContent(vehicle.infowWindowContent);
			}
		});
	}
	$('#fieldOptBackdrop').hide().removeClass('in');
	$('#fieldOpt').hide().removeClass('in');
  }

  evSelectAll(e){
	if(this.allDisplays){
		this.fieldDisplays.forEach((fld) => {
			fld.value = 1;
		})
	}else{
		this.fieldDisplays.forEach((fld) => {
			fld.value = 0;
		})
	}
  }

  selectFld(){
	let allFlds = this.fieldDisplays.length;
	let countingSel = 0;
	this.fieldDisplays.forEach((fld) => {
		if(fld.value){
			countingSel++;
		}
	});
	if(countingSel == allFlds){
		this.allDisplays = true;
	}else{
		this.allDisplays = false;
	}
  }

  confirmShare(){
	let initbaseShareUrl = this.apiSvc.baseendpoint;
	let vuid:any = this.share_vehicle_id;
	let encVhc = encodeURIComponent(btoa(vuid));
	let userObj = this.stateSvc.getLocalSession();
	let encUsr = encodeURIComponent(btoa(userObj?.username));

	// Get current datetime
	let now = new Date();
	// Add 1 hour
	now.setHours(now.getHours() + this.eff_time);
	// Format as Y-m-d H:i:s
	let year = now.getFullYear();
	let month = String(now.getMonth() + 1).padStart(2, '0'); // months are 0-based
	let day = String(now.getDate()).padStart(2, '0');
	let hours = String(now.getHours()).padStart(2, '0');
	let minutes = String(now.getMinutes()).padStart(2, '0');
	let seconds = String(now.getSeconds()).padStart(2, '0');
	let formatted = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
	let datetimeEnc = encodeURIComponent(btoa(formatted));

	this.baseShareUrl = initbaseShareUrl + "public-vehicle/"+encUsr+'/'+encVhc+'/'+datetimeEnc;
  }

  closeModalBtn(){
	$('#fieldOptBackdrop').hide().removeClass('in');
	$('#expirySet').hide().removeClass('in');
  }

  mapUpdateInfoWdw(unitid){
	let currentMapProvider = this.stateSvc.getMapType();
	this.vehicles.forEach((vhcl) => {
		if(vhcl.unitid == unitid){
			this.vehicleSvc.reverseGeocode(vhcl.lat, vhcl.lon)
			.subscribe((res) => {
				if(res && res != ""){
					vhcl.geolocation = res;
					if(currentMapProvider == "Google"){
						vhcl.infowWindowContent = this.vehicleSvc.writeInfoContent(vhcl, "", "");
						vhcl.infoWindow.setContent(vhcl.infowWindowContent);
					}else{
						vhcl.infowWindowContent = this.vehicleSvc.writeInfoContentOpenMap(vhcl, "", "");
						vhcl.marker.bindPopup(vhcl.infowWindowContent);
					}
					if(vhcl.menuGeocode){
						vhcl.location = res;
					}
				}
			});
			return;
		}
	});
  }
}
